import { createGlobalStyle, css } from "styled-components"

const hebrewFonts = css`
  @font-face {
    font-family: "NarkisBlock";
    src: url(/fonts/narkisblock-regular_mfw.woff) format("woff");
    font-weight: normal;

    font-display: swap;
  }

  @font-face {
    font-family: "NarkisBlock";
    src: url(/fonts/NarkisBlockCon-Bold_MFW.woff) format("woff");
    font-weight: bold;
    font-display: swap;
  }

  @font-face {
    font-family: "NarkisBlock-Medium";
    src: url(/fonts/NarkisBlock-Medium_MFW.woff) format("woff");
    font-weight: 500;

    font-display: swap;
  }

  @font-face {
    font-family: "NarkisBlockCondensed";
    src: url(/fonts/NarkisBlock-Condensed_MFW.woff) format("woff");
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: "NarkisBlock-Black";
    src: url(/fonts/NarkisBlock-Black_MFW.woff) format("woff");
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: "NarkisBlock-Thin";
    src: url(/fonts/NarkisBlockCon-Thin_MFW.woff) format("woff");
    font-weight: 100;
    font-display: swap;
  }
`
const hebrewContentFonts = css`
  @font-face {
    font-family: "NarkisBlockContent";
    src: url(/fonts/NarkisBlockMF-Bold.otf) format("opentype");
    font-weight: bold;
    font-display: swap;
  }
  @font-face {
    font-family: "NarkisBlockContent";
    src: url(/fonts/NarkisBlockMF-Regular.otf) format("opentype");
    font-weight: normal;
    font-display: swap;
  }
`
const englishFonts = css`
  @font-face {
    font-family: "Speedee";
    src: url(/fonts/SpeedeeCd_W_Lt.woff) format("woff");
    font-weight: 300;
    unicode-range: U+0041-007F;
    font-display: swap;
  }

  @font-face {
    font-family: "Speedee";
    src: url(/fonts/SpeedeeCd_W_Rg.woff) format("woff");
    font-weight: normal;
    unicode-range: U+0041-007F;
    font-display: swap;
  }

  @font-face {
    font-family: "Speedee";
    src: url(/fonts/SpeedeeCd_W_Bd.woff) format("woff");
    font-weight: bold;
    unicode-range: U+0041-007F;
    font-display: swap;
  }
`

const bitButtonFonts = css`
  @font-face {
    font-family: "poalimBit-light";
    src: url(/fonts/poalimBIT-Light.ttf);
    font-weight: 100;
    font-display: swap;
  }
  @font-face {
    font-family: "poalimBIT-Medium";
    src: url(/fonts/poalimBIT-Medium.ttf);
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    font-family: "poalimBit-bold";
    src: url(/fonts/poalimBIT-Bold.ttf);
    font-weight: bold;
    font-display: swap;
  }
`

const GlobalStyle = createGlobalStyle`
  ${hebrewFonts}
  ${englishFonts}
  ${bitButtonFonts}
  ${hebrewContentFonts}
  :root {
    direction: rtl;
    font-family: "Speedee", "NarkisBlockCondensed", sans-serif;
  }



  #__next {
    display: flex;
    flex-direction: column;
    width: 100%;
    ${(p) => p.theme.breakpoints.up("md")} {
      min-height: 100vh;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  * {
    box-sizing: border-box;
  }
  /* scrollbar: */
  body{
    overflow-y: scroll !important;
    background: white !important;
    height: auto !important;

  }
::-webkit-scrollbar {
  width:5px
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background-color:#45251C;
  border-radius:16px;
}
::-webkit-scrollbar-thumb:hover {
  background: #351c15;
}
/* todo move this to right place */
.MuiAutocomplete-paper {
      background-color: ${(p) => p.theme.colors.white} !important;
}

::selection {
  background: #ffbc0d;
}

`

export default GlobalStyle
